import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button, Row, Col } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { authActions } from "../../../../redux/actions";
import {
  GoogleMapConstants,
  sportConstants,
  spotConstants,
  translationConstants,
  fieldLengthConstants,
  DISALLOWED_KEYS_FOR_NUMBER_FIELD,
  Directions,
  CenterSpotStatusEnum,
  Regex,
  windDirectionsOptions,
  relativeToShoreOptions,
} from "../../../../constants";
import CustomModal from "../../../../shared/components/CustomModal/CustomModal";
import FindOnMapModal from "../../../../shared/components/Modals/FindOnMapModal";

const PrivateSpotModal = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    getValues,
    clearErrors,
  } = useForm();

  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const centerProfileData = useSelector(
    (state) => state.centersReducer?.centerProfileData?.centerSpots
  );

  const spotDataObj = useSelector((state) => state.SpotsReducer?.spotDataById);
  const cities = useSelector((state) => state.LoginReducer.cities);

  const [lng, setLng] = useState("");
  const [lat, setLat] = useState("");
  const [isShowMap, setShowMap] = useState(false);
  const [isDisableNameAndCoordinates, setIsDisableNameAndCoordinates] = useState(false);
  const [selectedCity, setSelectedCity] = useState("");
  const [ownEquipment, setOwnEquipment] = useState(
    props.data?.spotInfo?.hasOwnEquipment || false
  );
  const [isEntryFees, setIsEntryFees] = useState(
    props.data?.spotInfo?.isEntryFees || false
  );

  const onSubmit = (data) => {
    const hasOwnEquipment = data.hasOwnEquipment === "1" ? true : false;
    const dataToSend = {
      spotInfo: {
        ...data,
        isActive: true,
        lat: lat?.toString(),
        long: lng?.toString(),
        cityId: parseInt(selectedCity),
        spotTypeId: spotConstants.spotType.PRIVATE,
        entryFee: isEntryFees ? +data.entryFee : null,
        hasOwnEquipment: hasOwnEquipment,
      },
      sportIds: data.sports,
      id: spotDataObj?.id,
    };

    props.onSubmit(dataToSend);
  };

  const handleSaveLocation = () => {
    setValue(GoogleMapConstants.LATITUDE, lat);
    setValue(GoogleMapConstants.LONGITUDE, lng);
    trigger(GoogleMapConstants.LATITUDE);
    trigger(GoogleMapConstants.LONGITUDE);
    setShowMap(false);
  };

  const onSetShowMap = () => {
    const { latitude, longitude } = getValues();
    setLat(latitude);
    setLng(longitude);
    setShowMap((prev) => !prev);
  };

  // validation, at least one sport checkbox needs to be ticked
  const atLeastOneSportChecked = (selectedOptions) =>
    selectedOptions?.length > 0;

  useEffect(() => {
    //Set initial form values from selected spot
    if (props.data) {
      let data = props.data.spotInfo;
      setValue("name", data.name);
      setValue("arabicName", data.arabicName);
      setValue("locationName", data.locationName);
      setValue("arabicLocationName", data.arabicLocationName);
      setValue("latitude", data.lat);
      setValue("longitude", data.long);
      setValue("usualWindDrection", data.usualWindDrection);
      setValue("relativeToShore", data.relativeToShore);
      setValue("preferredWindDrection", data.preferredWindDrection);
      setValue("windSeason", data.windSeason);
      setValue("nearWindSensorURL", data.nearWindSensorURL);
      setValue("windForecastURL", data.windForecastURL);
      setValue("spotcity", data.cityId);

      setValue("isEntryFees", data.isEntryFees);
      setValue("entryFee", data.entryFee);
      setValue("isEntryFees", data?.entryFee ? true : false);
      setIsEntryFees(data?.entryFee ? true : false);

      setValue("sports", data.sports);

      //Fetch cities against country Saudi Arabia
      setSelectedCity(data.cityId);
      setLat(data.lat);
      setLng(data.long);

      setValue("hasOwnEquipment", data?.hasOwnEquipment ? "1" : "0");
    }

    // eslint-disable-next-line
  }, [props.data]);

  useEffect(() => {
    //Fetch cities against country Saudi Arabia
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));

    // eslint-disable-next-line
  }, []);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue.startsWith("-")) {
      e.target.value = "0";
    }
  };

  useEffect(() => {
    const filteredSpot = centerProfileData?.find(
      (x) => x?.spotId === spotDataObj?.id
    );
    if (
      spotDataObj?.id === filteredSpot?.spotId &&
      filteredSpot?.status === CenterSpotStatusEnum.Approved
    ) {
      setIsDisableNameAndCoordinates(true);
    }
  }, []);

  return (
    <>
      <Form
        noValidate
        className="ViewUserContent"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="ViewHeader">
          <p className="viewUserPara">
            {props.data
              ? t(translationConstants.EDIT_PRIVATE_SPOT)
              : t(translationConstants.CREATE_PRIVATE_SPOT)}
          </p>
        </div>
        <p className="horizentalLine" />

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {`${t(translationConstants.SPOT_NAME)}:*`}
            </Form.Label>
            <Form.Control
              {...register("name", {
                required: t(translationConstants.SPOT_NAME_REQUIRED),
              })}
              id="name"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              disabled={isDisableNameAndCoordinates}
            />
            {errors.name && <p className="errorText">{errors.name.message}</p>}
          </Form.Group>

          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.SPOT_NAME)}:
              <span className="greenColor">
                ({t(translationConstants.ARABIC)})
              </span>
            </Form.Label>
            <Form.Control
              dir={Directions.rtl}
              {...register("arabicName")}
              id="arabicName"
              type="text"
              maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
              disabled={isDisableNameAndCoordinates}
            />
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {`${t(translationConstants.SPOT_LOCATION_NAME)}:*`}
            </Form.Label>
            <Form.Control
              {...register("locationName", {
                required: t(translationConstants.SPOT_LOCATION_REQUIRED),
              })}
              id="locationName"
              type="text"
              maxLength={fieldLengthConstants.LOCATION_FIELD_LENGTH}
            />
            {errors.locationName && (
              <p className="errorText">{errors.locationName.message}</p>
            )}
          </Form.Group>
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.SPOT_LOCATION_NAME)}:{" "}
              <span className="greenColor">
                ({t(translationConstants.ARABIC)})
              </span>
            </Form.Label>
            <Form.Control
              dir={Directions.rtl}
              {...register("arabicLocationName")}
              id="arabicLocationName"
              type="text"
              maxLength={fieldLengthConstants.LOCATION_FIELD_LENGTH}
            />
          </Form.Group>
        </div>

        <div className="row mb-4">
          <Form.Group className="mt-2 col-12 col-lg-6 pe-0 position-relative">
            <Form.Label className="Form-labels">
              {`${t(translationConstants.SPOT_COORDINATES)}*:`}
              <span className="greenColor">
                ({t(translationConstants.LAT_LONG)})
              </span>
            </Form.Label>

            <div className="row me-lg-0">
              <Form.Group className="mt-2 col-lg-6 position-relative">
                <Form.Control
                  {...register("latitude", {
                    required: t(translationConstants.LAT_REQUIRED),
                    pattern: {
                      value: /^-?([1-8]?[0-9](\.\d+)?|90(\.0+)?)$/,
                      message: t(
                        translationConstants.LAT_RANGE_VALIDATION_TEXT
                      ),
                    },
                  })}
                  id="latitude"
                  type="text"
                  disabled={isDisableNameAndCoordinates}
                  onChange={(e) => {
                    const value = e.target.value;
                    setLat(value);
                    trigger(GoogleMapConstants.LATITUDE, +value);
                  }}
                />
                {errors.latitude && (
                  <p className="errorText">{errors.latitude.message}</p>
                )}
              </Form.Group>
              <Form.Group className="mt-2 col-lg-6 position-relative ps-lg-0">
                <Form.Control
                  {...register("longitude", {
                    required: t(translationConstants.LNG_REQUIRED),
                    pattern: {
                      value:
                        /^-?((([1-9]?[0-9]|1[0-7][0-9])(\.\d+)?)|180(\.0+)?)$/,
                      message: t(
                        translationConstants.LNG_RANGE_VALIDATION_TEXT
                      ),
                    },
                  })}
                  id="longitude"
                  type="text"
                  disabled={isDisableNameAndCoordinates}
                  onChange={(e) => {
                    const value = e.target.value;
                    setLng(value);
                    trigger(GoogleMapConstants.LONGITUDE, +value);
                  }}
                />
                {errors.longitude && (
                  <p className="errorText">{errors.longitude.message}</p>
                )}
              </Form.Group>
            </div>
          </Form.Group>

          {!props.isPrivateSpot && (
            <div className="col-12 col-lg-6 d-flex d-lg-block justify-content-center">
              <Form.Group className="mt-lg-4 position-relative">
                <Form.Label className="Form-labels"></Form.Label>
                <br />
                <Button
                  className="find-on-map-button mt-2 ms-0 back-none"
                  type="button"
                  onClick={onSetShowMap}
                  disabled={isDisableNameAndCoordinates}
                >
                  {t(translationConstants.FIND_ON_MAP)}
                </Button>
              </Form.Group>
            </div>
          )}
        </div>

        <div className="row mb-4 marginTop">
          <Form.Group className="mt-2 col-12 pe-lg-0 col-lg-3 position-relative">
            <Form.Label className="Form-labels">
              {`${t(translationConstants.PREVAILING_WIND_DIRECTION)}:*`}
            </Form.Label>
            <Form.Select
              {...register("usualWindDrection", {
                required: t(
                  translationConstants.PREVAILING_WIND_DIRECTION_REQUIRED
                ),
              })}
              aria-label="Default select example"
            >
              <option value="">
                {t(translationConstants.PREVAILING_WIND_DIRECTION)}
              </option>

              {windDirectionsOptions.map((direction) => (
                <option key={direction.id} value={direction.value}>
                  {direction.label}
                </option>
              ))}
            </Form.Select>
            {errors.usualWindDrection && (
              <p className="errorText">{errors.usualWindDrection.message}</p>
            )}
          </Form.Group>

          <Form.Group className="mt-2 col-12 col-lg-3 position-relative">
            <Form.Label className="Form-labels">
              {`${t(translationConstants.RELATIVE_TO_SHORE)}:*`}
            </Form.Label>
            <Form.Select
              {...register("relativeToShore", {
                required: t(translationConstants.RELATIVE_TO_SHORE_REQUIRED),
              })}
              aria-label="Relative to shore select"
            >
              <option value="">
                {t(translationConstants.RELATIVE_TO_SHORE)}
              </option>

              {relativeToShoreOptions.map((option) => (
                <option key={option.id} value={option.value}>
                  {t(option.label)}
                </option>
              ))}
            </Form.Select>
            {errors.relativeToShore && (
              <p className="errorText">{errors.relativeToShore.message}</p>
            )}
          </Form.Group>

          <Form.Group className="mt-2 col-lg-6  position-relative">
            <Form.Label className="Form-labels">
              {`${t(translationConstants.PREFERRED_WIND_DIRECTION)}:*`}
            </Form.Label>
            <Form.Select
              {...register("preferredWindDrection", {
                required: t(
                  translationConstants.PREFERRED_WIND_DIRECTION_REQUIRED
                ),
              })}
              aria-label="Default select example"
            >
              <option value="">
                {t(translationConstants.PREFERRED_WIND_DIRECTION)}
              </option>

              {windDirectionsOptions.map((direction) => (
                <option key={direction.id} value={direction.value}>
                  {direction.label}
                </option>
              ))}
            </Form.Select>
            {errors.preferredWindDrection && (
              <p className="errorText">
                {errors.preferredWindDrection.message}
              </p>
            )}
          </Form.Group>
        </div>

        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.WIND_SEASONS)} : (
              {t(translationConstants.optional)})
            </Form.Label>{" "}
            <Form.Control
              {...register("windSeason")}
              id="windSeason"
              type="text"
            />
          </Form.Group>
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {t(translationConstants.NEAR_WIND_SENSORS_LINK)} : (
              {t(translationConstants.optional)})
            </Form.Label>
            <Form.Control
              {...register("nearWindSensorURL", {
                pattern: {
                  value: Regex.urlRegex,
                  message: t(translationConstants.URL_VALIDATION),
                },
              })}
              id="nearWindSensorURL"
              type="text"
            />
            {errors.nearWindSensorURL && (
              <p className="errorText">{errors.nearWindSensorURL.message}</p>
            )}
          </Form.Group>
        </div>
        <div className="inputRow">
          <Form.Group className="form-group-register">
            <Form.Label className="Form-labels">
              {`${t(translationConstants.LINK_TO_WIND_FORECASTS)}:*`}
            </Form.Label>
            <Form.Control
              {...register("windForecastURL", {
                required: t(
                  translationConstants.LINK_TO_WIND_FORECASTS_REQUIRED
                ),
                pattern: {
                  value: Regex.urlRegex,
                  message: t(translationConstants.URL_VALIDATION),
                },
              })}
              id="windForecastURL"
              type="text"
            />
            {errors.windForecastURL && (
              <p className="errorText">{errors.windForecastURL.message}</p>
            )}
          </Form.Group>

          {cities.length > 0 && (
            <Form.Group className="form-group-register">
              <Form.Label htmlFor="spotCitySelect" className="Form-labels">
                {`${t(translationConstants.CITY)}:*`}
              </Form.Label>
              <Form.Select
                id="spotCitySelect"
                {...register("spotcity", {
                  required: t(translationConstants.CITY_IS_REQUIRED),
                })}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("spotcity", value, { shouldValidate: true });
                  setSelectedCity(value);
                  trigger("spotcity");
                  e.stopPropagation();
                }}
                aria-label="Default select example"
              >
                <option value="">{t(translationConstants.selectcity)}</option>
                {cities?.map((city) => (
                  <option key={city.id} value={city.id}>
                    {direction === Directions.rtl ? city.arabicName : city.name}
                  </option>
                ))}
              </Form.Select>
              {errors.spotcity && (
                <p className="errorText">{errors.spotcity.message}</p>
              )}
            </Form.Group>
          )}
        </div>

        <Col md={8} sm={12} className="mb-3">
          <Form.Label className="Form-labels">
            {`${t(translationConstants.CHOOSE_SPORTS_YOU_OFFER)}:*`}
          </Form.Label>
          <div className="d-flex flex-wrap justify-content-between col-md-12 px-0">
            <Form.Group
              className="d-flex flex-column justify-content-space-between"
              controlId="formBasicCheckbox1"
            >
              <Form.Check
                className="offer"
                type="checkbox"
                value={sportConstants.SAILING}
                label={<p>{t(translationConstants.sailing)} </p>}
                {...register("sports", {
                  validate: atLeastOneSportChecked,
                })}
              />
            </Form.Group>
            <Form.Group
              className="d-flex flex-column justify-content-space-between "
              controlId="formBasicCheckbox2"
            >
              <Form.Check
                className="offer"
                type="checkbox"
                value={sportConstants.KITESURFING}
                label={<p>{t(translationConstants.kitesurfing)} </p>}
                {...register("sports", {
                  validate: atLeastOneSportChecked,
                })}
              />
            </Form.Group>
            <Form.Group
              className="d-flex flex-column justify-content-space-between "
              controlId="formBasicCheckbox3"
            >
              <Form.Check
                className="offer"
                type="checkbox"
                value={sportConstants.WINDSURFING}
                label={<p>{t(translationConstants.windsurfing)} </p>}
                {...register("sports", {
                  validate: atLeastOneSportChecked,
                })}
              />
            </Form.Group>
            <Form.Group
              className="d-flex flex-column justify-content-space-between "
              controlId="formBasicCheckbox4"
            >
              <Form.Check
                className="offer"
                type="checkbox"
                value={sportConstants.WINGFOILING}
                label={<p>{t(translationConstants.wingfoiling)} </p>}
                {...register("sports", {
                  validate: atLeastOneSportChecked,
                })}
              />
            </Form.Group>
          </div>
          {errors.sports && (
            <p className="errorText">
              {t(translationConstants.ATLEAST_ONE_SPORT)}
            </p>
          )}
        </Col>

        <Col md={6} sm={12}>
          <Form.Group className="social-media-links" controlId="isEntryFees">
            <Form.Check
              type="checkbox"
              {...register("isEntryFees")}
              defaultChecked={props.data?.entryFee ? true : false}
              onChange={(e) => {
                setValue("entryFee", "");
                setIsEntryFees((prev) => !prev);
                const isChecked = e.target.checked;
                trigger("entryFee").then(() => {
                  if (!isChecked) {
                    clearErrors("entryFee");
                  }
                });
              }}
              label={
                <Row>
                  <Col xs={3} className="d-flex align-items-center">
                    <span className="text-nowrap">
                      {t(translationConstants.ENTRY_FEES)}
                    </span>
                  </Col>
                  <Col xs={9}>
                    <Form.Control
                      type="number"
                      disabled={!isEntryFees}
                      {...register("entryFee", {
                        min: {
                          value: 1,
                          message: t(
                            translationConstants.MINIMUM_VALUE_SHOULD_BE_1
                          ),
                        },
                        validate: (value) => {
                          if (isEntryFees && !value) {
                            return t(translationConstants.ENTRY_FEES_REQUIRED);
                          }
                          return true;
                        },
                      })}
                      onKeyDown={(e) => {
                        if (DISALLOWED_KEYS_FOR_NUMBER_FIELD.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onInput={handleInputChange}
                    />
                    {errors.entryFee && (
                      <p className="errorText">{errors.entryFee.message}</p>
                    )}
                  </Col>
                </Row>
              }
            />
          </Form.Group>
        </Col>

        <Col md={12} className="p-0 mb-3">
          <Form.Group>
            <div className="d-flex radio-button">
              <div className="row m-0 w-100">
                <div className="col-lg-4 px-0">
                  {" "}
                  <Form.Check
                    inline
                    value={0}
                    type="radio"
                    id="availableForTeachingOnly"
                    onChange={() => setOwnEquipment(false)}
                    label={t(translationConstants.AVAILABLE_FOR_TEACHING_ONLY)}
                    {...register("hasOwnEquipment", {
                      required: t(translationConstants.SPOT_TYPE_REQUIRED),
                    })}
                  />
                </div>
                <div className="col-lg-6 px-0">
                  <Form.Check
                    inline
                    value={1}
                    type="radio"
                    id="hasOwnEquipment"
                    onChange={() => setOwnEquipment(true)}
                    label={t(translationConstants.CAN_BRING_EQUIPMENT)}
                    {...register("hasOwnEquipment", {
                      required: t(translationConstants.SPOT_TYPE_REQUIRED),
                    })}
                  />
                </div>
              </div>
            </div>
            {errors.hasOwnEquipment && (
              <p className="errorText">{errors.hasOwnEquipment.message}</p>
            )}
          </Form.Group>
        </Col>

        <Row>
          <Col className="d-flex justify-content-center">
            <div className="d-flex">
              <Button className="UpdateUserView-button mx-2" type="submit">
                {!props.data
                  ? t(translationConstants.submit)
                  : t(translationConstants.Update)}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
      <CustomModal
        size="lg"
        scrollable={true}
        setShow={onSetShowMap}
        show={isShowMap}
      >
        <FindOnMapModal
          setLng={setLng}
          setLat={setLat}
          lat={lat}
          lng={lng}
          handleSubmitLocation={handleSaveLocation}
        />
      </CustomModal>
    </>
  );
};

export default PrivateSpotModal;
